
import axios from 'axios'
import { apiUrls } from './api';

export class FeedbackService {
  constructor (cookieService) {
    this.feedbackUrl = apiUrls.submitFeedback;
    this.cookieService = cookieService;
  }

  async sendFeedback (textUnderFocus, feedback) {
    await axios({
      method: 'POST',
      url: `${this.feedbackUrl}`,
      data: {
        hash: this.cookieService.getHashFromCookie(),
        textUnderFocus,
        feedback
      }
    });
  }
}